import { render, staticRenderFns } from "./ButtonFeedback.vue?vue&type=template&id=077284ae&"
import script from "./ButtonFeedback.vue?vue&type=script&lang=js&"
export * from "./ButtonFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFeedback.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports